/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

export type OralExamCloseTimeSlotRequestInProgressOutcome =
  (typeof OralExamCloseTimeSlotRequestInProgressOutcome)[keyof typeof OralExamCloseTimeSlotRequestInProgressOutcome];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OralExamCloseTimeSlotRequestInProgressOutcome = {
  grade: 'grade',
  void: 'void',
} as const;
